/*
  Fallback for the <details name> attribute.

  Current browsers close the other rows in a named group by themselves, so this
  only binds where they do not, which today means Safari before 17.2 and
  Firefox before 130. Feature detected rather than sniffed, so it stops running
  the moment a visitor's browser catches up.
*/
if (!('name' in HTMLDetailsElement.prototype) && !window.detailsExclusiveBound) {
  window.detailsExclusiveBound = true;

  // toggle does not bubble, so the listener has to run in the capture phase to
  // see it from the document.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const name = details.getAttribute('name');
      if (!name) return;

      document.querySelectorAll(`details[name="${CSS.escape(name)}"][open]`).forEach((other) => {
        if (other !== details) other.open = false;
      });
    },
    true
  );
}
